export default __webpack_public_path__ + "static/media/email.638ed0b7.png";